var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wish",on:{"click":_vm.wishClick}},[_c('img',{attrs:{"src":_vm.wish.iconUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }